import AiChat from "@/pages/AiChat";
export default function PartAI() {
  return <AiChat role="particulier" title="Assistant IA" suggestions={[
    "Estime le budget pour refaire ma salle de bain (5m²)",
    "Quels pros contacter pour rénover une cuisine ?",
    "Comment bien rédiger ma demande de devis ?",
  ]} />;
}
